import { ApiContent } from './api-content'
import { ApiEgg } from './api-egg'
import { ApiHCA } from './api-hca'
import { ApiPulses } from './api-pulses'
import { ApiSignUp } from './api-signup'
import { ApiWidget } from './api-widget'
import { ApiAI } from './api-ai'
import { ApiAssignation } from './api-assignation'

export const setNewToken = (token?: string | boolean) => {
    if (!token) token = false

    ApiHCA.defaults.headers.common.Authorization = token ? `Bearer ${token}` : token
    ApiSignUp.defaults.headers.common.Authorization = token ? `Bearer ${token}` : token
    ApiEgg.defaults.headers.common['access-token'] = token ? `${token}` : token
    ApiSignUp.defaults.headers.common.Authorization = token ? `Bearer ${token}` : token
    ApiPulses.defaults.headers.common.Authorization = token ? `Bearer ${token}` : token
    ApiWidget.defaults.headers.common.Authorization = token ? token : token
    ApiContent.defaults.headers.common.Authorization = token ? `Bearer ${token}` : token
    ApiAI.defaults.headers.common.Authorization = token ? `Bearer ${token}` : token
    ApiAssignation.defaults.headers.common.Authorization = token ? `Bearer ${token}` : token
}

export type Api<T> = {
    data: T
    success: boolean
    message: string
    code: number
}
